export default {
    generateUUID() {

        let uuid = window.sessionStorage.gUUID;
        if (!window.sessionStorage.gUUID) {
            let d = new Date().getTime()
            uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                let r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
            })
            window.sessionStorage.gUUID = uuid;
        }

        return uuid
    },
    quotationId(state, getters, rootState) {
        return state.quotationId
    },
    quotation(state, getters, rootState) {
        return state.quotation
    },
    lastQuotationSaved(state, getters, rootState) {
        return state.lastQuotationSaved
    },
    generateAuthenticationToken() {
        let client_id = "53ac945e-08e9-4e1d-8c9d-61ad3f10faeb"
        let secret_id = "ec77c189a266704d22a134942f4d89d882e5778a4f4fa66bccf89e92005d88b17a8a095522d3fba59beb757917cae7c8d71f10fad497cd30c9754120c8581101"
        return 'Basic ' + btoa(client_id + ':' + secret_id);
    },
    automationBearer(state, getters, rootState) {
        return state.automationBearer
    },
    newSelects(state, getters, rootState) {
        return state.newSelects
    },
}



// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/getters.js